const auth = {
    install(Vue) {
        Vue.directive('auth', {
            inserted(el, binding) {
                // 当前节点设置的权限
                const value = binding.value;

                // 读取用户当前拥有的权限
                const permissions = ['auth value'];

                // 如果用户没有权限，删除当前节点
                if (permissions.indexOf(value) < 0) {
                    el.parentNode.removeChild(el);
                }
            },
        });
    }
};

export default auth;